export default __webpack_public_path__ + "static/media/schools_bgSmall.b1c4928b.jpg";